//#region register
// request
export function RegisterCardModel() {
    this.returnUrl = null
}

/**
 *
 * @returns {import("@/types/AccountType.d").RegisterCardParamsModel}
 */
RegisterCardModel.prototype.getParams = function () {
    return {
        frontendReturnUrl: this.returnUrl
    }
}
// response
export function RegisterCardResponseModel(obj = null) {
    this.tranId = null
    this.webPaymentUrl  = null

    if (obj != null) {
        this.tranId = obj.tranId || null
        this.webPaymentUrl  = obj.webPaymentUrl  || null
    }
}

// builder
export function RegisterCardModelBuilder() {
    this.model = new RegisterCardModel()
}

/**
 *
 * @returns {RegisterCardModel}
 */
RegisterCardModelBuilder.prototype.create = function () {
    return this.model
}

/**
 *
 * @param {string} url
 * @returns {boolean} - result of set url
 */
RegisterCardModelBuilder.prototype.setReturnUrl = function (url) {
    // do nothing if url is not string
    if (typeof url != "string") return false

    this.model.returnUrl = url
    return true
}
//#endregion register

//#region verify card
export function VerifyCardModel() {
    this.transactionId = null
}

/**
 *
 * @returns {import("@/types/AccountType.d").VerifyCardParamsModel}
 */
VerifyCardModel.prototype.getParams = function () {
    return {
        tranId: this.transactionId
    }
}

export function VerifyCardModelBuilder() {
    this.model = new VerifyCardModel()
}

VerifyCardModelBuilder.prototype.create = function () {
    return this.model
}

VerifyCardModelBuilder.prototype.setTransactionId = function (id) {
    if (typeof id != "string") return false

    this.model.transactionId = id
    return true
}
//#endregion verify card

export default {
    RegisterCardModel,
    RegisterCardModelBuilder,
    VerifyCardModel,
    VerifyCardModelBuilder
}
